<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import TabVertical from 'comp/content/TabVertical'
import Title2Logo from '../common/Title2Logo.vue'
import FileBox from '../common/FileBox.vue'
import NoData from 'comp/common/NoData'
import FilePreview from 'comp/content/FilePreview.vue'

import { getSubPageId11 } from '@/api/pageData'

export default {
  name: 'DialogId2',
  components: { ModuleTitle, TabVertical, Title2Logo, FileBox, NoData, FilePreview },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    },
    currentModuleItemDataHeadline: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      path: this.$route.path,
      tabList: [],
      tabActive: 0,
      currentTab: {},
      pageData: [],
      currentPageList: [],
      currentPageData: {},
      previewShow: false
    }
  },
  watch: {
    currentTab(newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parent = document.querySelector('.dialog-content-main')
          parent.scrollTo({ top: 0, behavior: 'smooth' })
        }, 200)
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    onTabClick(id) {
      this.tabList.forEach((item, idx) => {
        if (item.id === id && this.currentTab.id !== item.id) {
          this.tabActive = idx
          this.currentTab = item
          this.currentPageList = this.pageData[idx].list
        }
      })
    },
    onFileClick(v) {
      this.currentPageData = v
      this.previewShow = true
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        userid: localStorage.getItem('screenUserid') || 0
      }
      getSubPageId11(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg || []
          // this.currentPageList = res.msg[0].list || []
          let arr = []
          res.msg.forEach((item, idx) => {
            arr.push({ id: idx + 1, title: item.subtitle })
          })
          this.tabList = arr
          this.tabList.length > 0 && this.tabList.forEach((item, idx) => {
            if (item.title === this.currentModuleItemDataHeadline) {
              this.tabActive = idx
              this.currentTab = item
              this.currentPageList = res.msg[idx].list || []
            }
          })
          // this.currentTab = this.tabList[0]
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-2">
    <module-title :title="currentModule.title" margin-bottom="40" />
    <div class="main-container">
      <div class="left-container">
        <title2-logo :headline="currentTab.title || '暂无'" />
        <div v-if="currentPageList.length > 0" class="file-group-box">
          <div v-if="currentPageList[0].typeid != 2" class="file-group">
            <file-box
              v-for="(v, i) in currentPageList"
              :key="`dialog11-file-${i}`"
              :type="v.typeid"
              :headline="v.headline"
              :cover="v.photo"
              :createtime="v.createtime"
              :filename="v.typename"
              @click.native="onFileClick(v)"
            />
          </div>
          <div v-else class="img-group">
            <div v-for="(v, i) in currentPageList" :key="`img-item-${i}`" class="item">
              <el-image :src="v.photo | imgPath" alt="acti" fit="cover" class="item-img" />
              <p class="item-title">{{ v.headline }}</p>
            </div>
          </div>
        </div>
        <no-data v-else class="no-data-box" />
      </div>
      <div class="right-container">
        <tab-vertical
          :page-data="tabList"
          :tab-active="tabActive"
          :has-img="false"
          @onTabClick="onTabClick"
        />
      </div>
    </div>

    <file-preview
      :preview-show="previewShow"
      :type="currentPageData.typeid"
      :info-id="currentPageData.id"
      :headline="currentPageData.headline"
      :filename="currentPageData.typename"
      :content="currentPageData.memo"
      :createtime="currentPageData.createtime"
      @onModalClick="previewShow = false"
    />
  </div>
</template>

<style lang="scss" scoped>
// 1330
// .dialog-id-2 {
//   display: flex;
// }
.main-container {
  display: flex;
  position: relative;
  margin-top: 60px;
}
.left-container {
  width: 710px;
  margin-left: 100px;
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .time {
    font-size: 14px;
    font-weight: bold;
    color: #B3B3B3;
    margin-top: 20px;
  }
  .rich-text {
    width: 710px;
    margin-top: 25px;
  }
  .file-group-box {
    width: 100%;
  }
  .file-group, .img-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 30px;
  }
}
.right-container {
  position: fixed;
  margin-left: 910px;
}
.img-group {
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-img {
      width: 340px;
      height: 210px;
      border-radius: 5px;
    }
    .item-title {
      width: 320px;
      font-size: 18px;
      font-weight: bold;
      color: #000;
      line-height: 29px;
      margin-top: 20px;
    }
  }
}
.no-data-box {
  margin-top: 20px;
}
</style>
